<template>
  <div class="hs-transfer">

    <div class="leftPanel">
      <div class="searchInputContainer">
        <el-input
          :placeholder="leftPlaceholder?leftPlaceholder:''"
          suffix-icon="el-icon-search"
          clearable
          v-model="leftFilterText">
        </el-input>
      </div>

      <div class="trreeContainer">
        <el-tree 
          ref="tree"
          class="leftTree"
          v-bind="elTreeBind"
          :props="defaultProps"
          show-checkbox
          @check="treeChange"
          :node-key="nodekey" 
          :filter-node-method="filterNode"
          :data="treeData">
        </el-tree>
      </div>
    </div>

    <div class="rightPanel">
      <div class="searchInputContainer">
        <el-input
          :placeholder="rightPlaceholder?rightPlaceholder:''"
          suffix-icon="el-icon-search"
          clearable
          v-model="rightFilterText">
        </el-input>
      </div>

      <ul class="choseUl" v-if="showChoseList.length>0">
        <li v-for="(item,index) in showChoseList " :disabled="item.disabled" :key="index">
          <p class="item-name">{{item[labelName]}}</p>
          <span class="deleteIcon" @click="deleteChose(item)" v-if="showDelete">
            <i class="el-icon-error"></i>
          </span>
        </li>
      </ul>
      <div class="noData" v-else>
        <span class="noDataSpan">{{t('table.emptyText')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '../../mixins/locale';
export default {
  name:'HsTreeTransfer',
  mixins: [Locale],
  props: {
    /** 左侧搜索框placeholder提示文字 */
    leftPlaceholder: {
      type: String,
      default:''
    },
    /** 左侧搜索框placeholder提示文字 */
    rightPlaceholder: {
      type: String,
      default:''
    },
    /** 左侧树形结构props */
    defaultProps: {
      type: Object,
      default: function () {
        return {}
      }
    },
    /**树形结构唯一标识 */
    nodekey: {
      type: String,
      default:'id'
    },
    /** 右侧list显示区分类型显示 */
    checkTypeShow: {
      type: Array,
      default: function () {
        return []
      }
    },
    /** 是否显示右侧删除按钮图标 */
    showDelete: {
      type: Boolean,
      default: true
    },
    /**右侧树形结构bind element属性 */
    elTreeBind: {
      type: Object,
      default: function () {
        return {};
      }
    },
    /**树形结构 */
    treeData: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  computed: {
    labelName() {
      return this.defaultProps?.label ? this.defaultProps.label : 'label';
    },
    showChoseList() {
      return this.filterChoseList(this.choseList)
    }
    // this.defaultProps?.id ? this.defaultProps.id : 'id';
    // choseList(){
    //     // if(this.showChoseType){
    //     //     return this.orgChoseList;
    //     // }else{
    //     //     return this.storeChoseList;
    //     // }
    //   }
  },
  watch: {
    leftFilterText(val) {
      this.$refs.tree.filter(val);
    },
    rightFilterText() {
      this.filterChoseList();
    }
  },
  data() {
    return {
      leftFilterText:'',
      rightFilterText:'',
      choseList: [],
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    filterChoseList() {
      let returnArr = [];
      if (this.rightFilterText != '') {
        returnArr = this.choseList.filter(item => {
          let labelContent = item[this.labelName] || '';
          return labelContent.includes(this.rightFilterText);
        })
      } else {
        returnArr = [...this.choseList];
      }

      return returnArr;
    },
    treeChange() {
      if (this.checkTypeShow.length) {
        console.log(this.checkTypeShow);
        let choseList = [];
        this.checkTypeShow.forEach(type => {
          let typeChose = this.getCheckedNodes().filter(item => item.nodeType == type);
          choseList.push(...typeChose);
        })
        this.choseList =  Array.from(new Set(choseList));
      } else {
        this.choseList = this.getCheckedNodes();
      }
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes(arguments);
    },
    setDefaultCheck() {
      
    },
    reverseElectionChildren(data,node) {
      let checkStatus = !node.checked;
      let changeIds = this.getIds([data]) || [];

      let choseKeys = this.$refs.tree.getCheckedKeys() || [];
      let changeCheck = [];
      if(checkStatus){
        changeCheck = Array.from(new Set([...changeIds,...choseKeys]));
      }else{
        changeCheck = choseKeys.filter( item => !changeIds.includes(item));
      }
      this.$nextTick( () => {
        this.$refs.tree.setCheckedKeys(changeCheck);
        this.orgChoseList = this.$refs.tree.getCheckedNodes().filter( item => item.nodeType == 'org');
        this.storeChoseList = this.$refs.tree.getCheckedNodes(true).filter( item => item.nodeType == 'store');
      });
    },

    getIds (data) {
      const res = [];
      function fn(checkData) {
        checkData.map(node => {
          if (node.children) {
            if(!node.disabled){
              res.push(node.id);
            }
            fn(node.children);
          } else {
            if(!node.disabled){
              res.push(node.id);
            }
          }
        });
      }
      fn(data);
      return res;
    },
    deleteChose(item) {
      let deleteIndex = this.choseList.findIndex(list => list[this.nodekey] === item[this.nodekey]);
      this.choseList.splice(deleteIndex,1);
      const idVal = item[this.nodekey];
      if (idVal != undefined) {
        this.$refs.tree.setChecked(idVal, false);
      }
    }
  }
}
</script>
<style lang="scss">
.hs-transfer{
  .el-tree-node__content{
    height: auto;
    align-items: flex-start;
    white-space: pre-wrap !important;
    word-wrap: break-word;
    word-break: break-all;
 
    // .el-tree-node__label{

    // }
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // flex-grow: 1;
    // flex-wrap: nowrap;

    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 2;
    // overflow: hidden;
  }
}
</style>
<style lang="scss" scoped>
.hs-transfer{
  padding: 10px;
  display: flex;
  .searchInputContainer{
    padding: 8px;
    border-bottom: 1px solid #E7E7E7;
  }
  .trreeContainer{
    padding-top: 15px;
    padding-right: 8px;
  }
  .leftPanel{
    box-sizing: border-box;
    flex:1;
    max-width: 240px;
    min-height: 400px;
    overflow-y: auto;
    border-right: 1px solid #E7E7E7;
  }
  .rightPanel{
    flex:1;
    max-width: 240px;

    .choseUl{
      padding: 16px 7px;
      margin: 0;
      list-style: none;
      li{
        display: flex;
        flex-wrap: nowrap;
        height: 25px;
        padding: 0 5px;
        align-items: center;
        font-size: 12px;
        text-indent: 10px;
        margin: 0;
        p{
          margin: 0;
        }
        .item-name{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-grow: 1;
          color: #606266;
          flex-wrap: nowrap;
        }
        .deleteIcon{
          padding-left: 10px;
          color: #CCCCCC;
          cursor: pointer;
        }

        &:hover{
          background-color: #F5F7FA;
          .deleteIcon{
            color:#015AC5;
          }
        }
      }
    }
    .noData{
      padding-top: 15px;
      min-height: 60px;
      line-height: 60px;
      text-align: center;
      width: 100%;
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>